import { render, staticRenderFns } from "./SubProducts.vue?vue&type=template&id=6705f0dc&scoped=true"
import script from "./SubProducts.vue?vue&type=script&lang=js"
export * from "./SubProducts.vue?vue&type=script&lang=js"
import style0 from "./SubProducts.vue?vue&type=style&index=0&id=6705f0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6705f0dc",
  null
  
)

export default component.exports